import { useLocation } from "react-router-dom";

export const useSolidHeader = () => {
  const location = useLocation();

  return location.pathname.includes('/noticias') || 
          location.pathname.includes('/blog')|| 
          location.pathname.includes('/listado-cursos/');
}
